import { equals, isEmpty, not } from 'rambda';
import { filter } from 'fp-ts/lib/Array';
import { flow } from 'fp-ts/lib/function';

export const raEnabled = flow(filter<string>(equals('csos_ra')), isEmpty, not);

export const diEnabled = flow(filter<string>(equals('csos_di')), isEmpty, not);

export const helpDeskEnabled = flow(
  filter<string>(equals('csos_helpdesk')),
  isEmpty,
  not
);
